import { BrowserCacheLocation, Configuration } from '@azure/msal-browser';

import { Injectable } from '@angular/core';
import { b2c } from '@tcb/environment';

export const constants = {
	additionalStateKeyInStorage: 'additional_state',
	migrationOnDemandEnabledKeyInStorage: 'migration_on_demand_enabled',
};

@Injectable()
export class LocalStorageService {
	constructor() {}

	setAdditionalState(state: string): void {
		localStorage.setItem(constants.additionalStateKeyInStorage, state);
	}

	getAdditionalState(): string | null {
		return localStorage.getItem(constants.additionalStateKeyInStorage);
	}

	setMigrationOnDemandEnabled(enabled: boolean): void {
		localStorage.setItem(
			constants.migrationOnDemandEnabledKeyInStorage,
			enabled.toString(),
		);
	}

	getMigrationOnDemandEnabled(): boolean {
		return (
			localStorage.getItem(
				constants.migrationOnDemandEnabledKeyInStorage,
			) == 'true'
		);
	}

	clear() {
		localStorage.removeItem(constants.additionalStateKeyInStorage);
	}
}

export const b2cPolicies = {
	names: {
		signUpSignIn: b2c.signUpSignInPolicyName,
		resetPassword: b2c.passwordResetPolicyName,
		forgotPassword: b2c.forgotPasswordPolicyName,
	},
	authorities: {
		signUpSignIn: {
			authority: `${b2c.authorityBase}/${b2c.signUpSignInPolicyName}`,
		},
		resetPassword: {
			authority: `${b2c.authorityBase}/${b2c.passwordResetPolicyName}`,
		},
		forgotPassword: {
			authority: `${b2c.authorityBase}/${b2c.forgotPasswordPolicyName}`,
		},
		changeEmailAddress: {
			authority: `${b2c.authorityBase}/${b2c.changeEmailAddressPolicyName}`,
		},
	},
	authorityDomain: b2c.authorityDomain,
};

const isIE =
	window.navigator.userAgent.indexOf('MSIE ') > -1 ||
	window.navigator.userAgent.indexOf('Trident/') > -1;

const migrationOnDemandEnabled =
	new LocalStorageService().getMigrationOnDemandEnabled();
const clientId = migrationOnDemandEnabled
	? b2c.migrationOnDemandClientId
	: b2c.defaultClientId;

export const msalConfig: Configuration = {
	auth: {
		clientId: clientId, // This is the ONLY mandatory field that you need to supply.
		authority: b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
		knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
		redirectUri: b2c.loginRedirectUri, // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
		postLogoutRedirectUri: b2c.logoutRedirectUri, // Points to window.location.origin by default.
	},
	cache: {
		cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
		storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
	},
	system: {
		/**
		 * Below you can configure MSAL.js logs. For more information, visit:
		 * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
		 */
		allowRedirectInIframe: true,
		loggerOptions: {
			//loggerCallback(logLevel: LogLevel, message: string) {},
			logLevel: b2c.logLevel,
			piiLoggingEnabled: false,
		},
		tokenRenewalOffsetSeconds: 300, // Sets the window of offset needed to renew the token before expiry. E.g., if acquireTokenSilent() is called within 300 seconds of tokens expiring, the call will attempt to refresh the tokens
	},
};

export const loginRequest = {
	scopes: [b2c.scope],
};
